export default {
  title: 'Domeniul propriu',
  description:
    'Rulați aplicațiile echipei dvs. pe un domeniu propriu în loc de adresa comună. Conectați domeniul o singură dată: panoul, portalul de comenzi, editorul de site și studioul de site primesc fiecare câte o adresă sub acesta.',
  read_only_description:
    'Domeniul pe care acest partener își rulează aplicațiile. Doar partenerul îl poate conecta sau deconecta.',
  read_only_empty: 'Acest partener nu a conectat niciun domeniu.',
  not_connected: {
    label: 'Domeniu',
    hint: 'Domeniul care vă aparține, fără www — de exemplu marcadvs.ro. Apoi adăugați înregistrările DNS afișate la furnizorul dvs. de domeniu.',
    placeholder: 'marcadvs.ro',
    connect: 'Conectați',
  },
  apps: {
    dashboard: 'Panou',
    oms: 'Portal de comenzi',
    storefront: 'Editor de site',
    website_studio: 'Studio de site',
  },
  status: {
    active: 'Activ',
    pending: 'Se așteaptă DNS',
    failed: 'Necesită atenție',
    disabled: 'Deconectat',
  },
  records: {
    title: 'Adăugați aceste înregistrări DNS pentru {{root}} la furnizorul dvs. de domeniu',
  },
  instructions: {
    title: 'Cum adăugați înregistrările',
    step_provider:
      'Autentificați-vă acolo unde este administrat DNS-ul pentru {{root}} — de obicei la furnizorul de la care ați cumpărat domeniul sau la un serviciu DNS precum Cloudflare.',
    step_add:
      'Deschideți setările DNS pentru {{root}} și adăugați fiecare înregistrare de mai jos: alegeți tipul, apoi copiați numele și valoarea exact așa cum sunt. Lăsați TTL-ul la valoarea implicită.',
    step_check:
      'Salvați înregistrările, apoi faceți clic pe „{{button}}”. Majoritatea furnizorilor publică modificările în câteva minute; unii au nevoie de până la 48 de ore.',
    tip_name:
      'În câmpul pentru nume, majoritatea furnizorilor așteaptă doar partea dinainte de {{root}}, afișată îngroșat. Dacă furnizorul dvs. cere numele complet, copiați-l pe cel de dedesubt.',
    tip_cloudflare:
      'În Cloudflare, setați înregistrările CNAME pe „Doar DNS” (nor gri). O înregistrare prin proxy ascunde CNAME-ul, așa că domeniul nu poate fi verificat.',
    tip_existing:
      'Nu modificați înregistrările existente pentru {{root}} și www — site-ul dvs. funcționează în continuare.',
  },
  summary: {
    live: 'Panoul dvs. este activ pe {{host}}.',
    pending: 'Verificăm periodic înregistrările dvs. DNS. Găsirea înregistrărilor noi poate dura până la 48 de ore.',
    failed:
      'Unele înregistrări nu au putut fi verificate. Corectați înregistrările marcate mai jos, apoi verificați din nou.',
    relogin:
      'După ce {{host}} devine activ, echipa dvs. se autentifică acolo. La prima vizită va fi necesară o nouă autentificare.',
  },
  buttons: {
    check_again: 'Verificați din nou',
    disconnect: 'Deconectați',
    retry: 'Încercați din nou',
  },
  disconnect_confirm: {
    title: 'Deconectați {{root}}?',
    description: 'Aplicațiile dvs. revin la adresa comună, iar linkurile de pe {{root}} nu mai funcționează.',
    ok: 'Deconectați',
  },
  toasts: {
    load_error: 'Nu am putut încărca domeniul dvs.',
    load_error_read_only: 'Domeniul acestui partener nu a putut fi încărcat.',
    connected: 'Domeniu conectat. Adăugați înregistrările DNS de mai jos.',
    connect_failed: 'Nu am putut conecta domeniul.',
    check_started: 'Se verifică înregistrările dvs. DNS.',
    check_failed: 'Nu am putut porni verificarea. Încercați din nou peste un minut.',
    disconnected: 'Domeniu deconectat.',
    disconnect_failed: 'Nu am putut deconecta domeniul.',
  },
};
